export default __webpack_public_path__ + "static/pedersen-glacier-ef6e99cc560e650ed7baf9d5c5835e6b.png";